import { render } from "./icon-box-arrow-up-right.vue?vue&type=template&id=3dd4d2b4"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__